import { render, staticRenderFns } from "./ruitian-news.vue?vue&type=template&id=0361317f&scoped=true"
import script from "./ruitian-news.vue?vue&type=script&lang=js"
export * from "./ruitian-news.vue?vue&type=script&lang=js"
import style0 from "./ruitian-news.vue?vue&type=style&index=0&id=0361317f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0361317f",
  null
  
)

export default component.exports